import React from 'react';

/** Candidate stages (T0: no "Rejected"). */
export const STAGES = { review: 'Needs review', shortlisted: 'Shortlisted', notstarted: 'Not started' };

export function StagePill({ stage }) {
  return <span className={`wz-stage ${stage}`}>{STAGES[stage] || stage}</span>;
}

function Status({ label, dot, color }) {
  return (
    <span className="wz-status" style={{ color }}>
      <span className="wz-dot" style={{ background: dot }} />
      {label}
    </span>
  );
}

/** Prototype statusDot(): Live / Draft. */
export function StatusDot({ live }) {
  return live
    ? <Status label="Live" dot="var(--wz-pass-dot)" color="var(--wz-pass)" />
    : <Status label="Draft" dot="var(--wz-ghost)" color="var(--wz-muted)" />;
}

/** Batch lifecycle: scheduled (window not open yet) → open → closed. */
export const BATCH_STATUS = {
  scheduled: ['Scheduled', 'var(--wz-warn-dot)', 'var(--wz-review-fg)'],
  open: ['Open', 'var(--wz-pass-dot)', 'var(--wz-pass)'],
  closed: ['Closed', 'var(--wz-ghost)', 'var(--wz-muted)'],
};

export function BatchStatus({ status }) {
  const [label, dot, color] = BATCH_STATUS[status] || BATCH_STATUS.scheduled;
  return <Status label={label} dot={dot} color={color} />;
}

export function BatchPill({ name }) {
  return <span className="wz-bpill">{name}</span>;
}

/** Result status used in result rows: Completed / Scoring / In progress / Not started. */
const RESULT_STATUS = {
  done: ['Completed', 'var(--wz-pass-dot)', 'var(--wz-pass)'],
  scoring: ['Scoring', 'var(--wz-ghost)', 'var(--wz-ink-3)'],
  inprogress: ['In progress', 'var(--wz-warn-dot)', 'var(--wz-review-fg)'],
  interrupted: ['Interrupted', 'var(--wz-danger)', 'var(--wz-danger)'],
  invited: ['Not started', 'var(--wz-warn-dot)', 'var(--wz-review-fg)'],
};

export function ResultStatus({ state, interrupted = false }) {
  // Interrupted = in progress, but the candidate dropped off (connection lost / browser closed).
  const key = state === 'inprogress' && interrupted ? 'interrupted' : state;
  const [label, dot, color] = RESULT_STATUS[key] || RESULT_STATUS.invited;
  return <Status label={label} dot={dot} color={color} />;
}
